import api from "./api";

export const getEvents = async () => {
    try {
        const response = await api.get(`/events?populate=*`);
        // console.log(response.data.data);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const eventsCount = async () => {
    try {
        const response = await getEvents();
        // console.log(response);
        const length = response.length;
        // console.log(length);
        return length;
    } catch (e) {
        console.error(e);
    }
};

export const getSingleEvent = async (id) => {
    try {
        const response = await api.get(`/events/${id}?populate=*`);
        // console.log(response.data.data);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const getFilteredEvents = async (filters = {}, page = 1, pageSize = 12) => {
    try {
        const queryParams = {
            populate: '*',
            filters: {},
            pagination: {
                page,
                pageSize
            }
        };

        // Add price filter if provided
        if (filters.price) {
            queryParams.filters.price = {
                $eq: filters.price
            };
        }

        // Add city filter if provided
        if (filters.city) {
            queryParams.filters.city = {
                $eq: filters.city
            };
        }

        // Add category filter if provided
        if (filters.category) {
            queryParams.filters.category = {
                id: {
                    $eq: filters.category
                }
            };
        }

        // Add search term if provided
        if (filters.search) {
            queryParams.filters.$or = [
                {
                    name: {
                        $containsi: filters.search
                    }
                },
                {
                    description: {
                        $containsi: filters.search
                    }
                }
            ];
        }

        // Add sorting if provided
        if (filters.sort) {
            queryParams.sort = [filters.sort];
        }

        const response = await api.get('/events', { params: queryParams });
        return {
            data: response.data.data,
            pagination: response.data.meta.pagination
        };
    } catch (e) {
        console.error(e);
        return {
            data: [],
            pagination: {
                page: 1,
                pageSize: pageSize,
                pageCount: 0,
                total: 0
            }
        };
    }
};

export const deleteEvent = async (id) => {
    try {
        const response = await api.delete(`/events/${id}`);
        console.log(response);
        return true;
    } catch (err) {
        console.error('Error deleting event:', err);
        return false
    }
};